<template>
  <w-icon-wrapper icon-name='work-copy-project-icon'>
    <path
      id='Pfad_55680'
      d='M0,4V24H16V10L10,4ZM14,22H2V6H8v6h6ZM10,10V6.83L13.17,10Z'
      data-name='Pfad 55680'
      fill='currentColor'
    />
    <path
      id='Pfad_55681'
      d='M18,0H8V3h2V2h6V8h6V18H17v2h7V6Zm0,6V2.83L21.17,6Z'
      data-name='Pfad 55681'
      fill='currentColor'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCopyProject' };
</script>
